import React, { useState } from 'react';
import {
  Container,
  HeaderWrapper,
  MainWrapper,
} from 'lib/components/styles/layout';
import { Heading } from 'lib/components/styles/typography';
import { Button } from 'react-covideo-common';
import { HiPlus } from 'react-icons/hi';
import { Search } from 'lib/components';
import {
  IGetQuickVideosParams,
  useGetQuickVideos,
} from 'lib/api/quickVideo/useGetQuickVideos';
import {
  DEFAULT_PAGE,
  DEFAULT_SIZE,
  PaginationConstants,
} from 'lib/const/PaginationConstants';
import { IQuickVideo, QuickVideoSortKeys } from 'lib/api/quickVideo/types';
import { QuickVideosList } from '../components/QuickVideosList';
import { useHistory } from 'react-router';
import { SelectedQuickVideosRibbon } from '../components/SelectedQuickVideosRibbon';

export const Main = () => {
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [limit, setLimit] = useState(DEFAULT_SIZE);
  const [order, setOrder] = useState<PaginationConstants>(
    PaginationConstants.ASCENDING
  );
  const [sortKey, setSortKey] = useState<QuickVideoSortKeys | null>(null);
  const [selectedQuickVideos, setSelectedQuickVideos] = useState<IQuickVideo[]>(
    []
  );

  const params: IGetQuickVideosParams = {
    start: page * limit,
    limit: limit || DEFAULT_SIZE,
    search: searchQuery,
    order,
    sortKey,
  };
  const { data, isFetching } = useGetQuickVideos(params);
  const quickVideos = data?.quickVideos || [];
  const count = data?.count || 0;
  const isDisabled = isFetching;

  const onPaginationChange = async ({
    page: newPage,
    size: newSize,
  }: {
    page: number;
    size: number;
  }) => {
    setPage(newPage);
    setLimit(newSize);
  };

  const onSortChange = (
    newSortKey: QuickVideoSortKeys,
    newOrder: PaginationConstants
  ) => {
    setOrder(newOrder);
    setSortKey(newSortKey);
  };

  return (
    <Container>
      <MainWrapper resetPadding={false}>
        <HeaderWrapper>
          <Heading>Quick Videos</Heading>
          <Button
            onClick={() => {
              history.push('/ai-configuration/quick-videos/new');
            }}
            text='Add Quick Video'
            disabled={isDisabled}
            icon={<HiPlus />}
          />
        </HeaderWrapper>
        <Search
          width='300px'
          onSearch={value => setSearchQuery(value)}
          prevSearch={searchQuery}
          placeholder='Search videos'
          disabled={isDisabled}
        />

        <QuickVideosList
          isLoading={isFetching}
          data={quickVideos}
          count={count}
          page={page}
          limit={limit}
          searchQuery={searchQuery}
          onPaginationChange={onPaginationChange}
          order={order}
          sortKey={sortKey}
          onSortChange={onSortChange}
          selectedQuickVideos={selectedQuickVideos}
          setSelectedQuickVideos={setSelectedQuickVideos}
        />
        <SelectedQuickVideosRibbon
          selectedQuickVideos={selectedQuickVideos}
          setSelectedQuickVideos={setSelectedQuickVideos}
          quickVideos={quickVideos}
        />
      </MainWrapper>
    </Container>
  );
};
